import {
  EntityAvatar,
  EntityAvatarFallback,
  EntityAvatarImage,
  getInitials,
  Text,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

type WorkspaceAvatarSize = "2xs" | "sm" | "default";

type WorkspaceAvatarProps = Omittable<{
  name: string;
  logo?: string | null;
  size?: WorkspaceAvatarSize;
}>;

const TEXT_PROPS_MAP: Record<
  WorkspaceAvatarSize,
  { size: "2xs" | "xs" | "sm"; weight: "medium" | "semibold" }
> = {
  default: { size: "sm", weight: "medium" },
  sm: { size: "xs", weight: "semibold" },
  "2xs": { size: "2xs", weight: "semibold" },
};

export function WorkspaceAvatar({
  name,
  logo,
  size = "sm",
}: WorkspaceAvatarProps) {
  const text = TEXT_PROPS_MAP[size];
  return (
    <EntityAvatar size={size} shape="square" alt={name}>
      {logo ? <EntityAvatarImage src={logo} alt={name} /> : null}
      <EntityAvatarFallback>
        <Text size={text.size} weight={text.weight}>
          {getInitials(name)}
        </Text>
      </EntityAvatarFallback>
    </EntityAvatar>
  );
}
